import React, { useState } from 'react';
import '../../styles/vendeurs/VendeurForm.css';
import { validerVendeurById, rejeterVendeurById } from '../../services/vendeurs/vendeurAdminService';
import { asset } from '../../services/api'; // ✅ utiliser asset

function VendeurDetails({ vendeur, onBack }) {
  const [remarque, setRemarque] = useState('');

  if (!vendeur) return null;

  const valider = async () => {
    if (!window.confirm("Valider ce vendeur ?")) return;
    try {
      await validerVendeurById(vendeur.id);
      alert("Vendeur validé.");
      onBack();
    } catch {
      alert("Erreur lors de la validation.");
    }
  };

  const rejeter = async () => {
    if (!remarque) return alert("Veuillez entrer une remarque.");
    if (!window.confirm("Rejeter ce vendeur avec remarque ?")) return;
    try {
      await rejeterVendeurById(vendeur.id, remarque);
      alert("Vendeur rejeté.");
      onBack();
    } catch {
      alert("Erreur lors du rejet.");
    }
  };

  return (
    <div className="vendeur-details-container">
      <button className="back-btn" onClick={onBack}>Retour</button>
      <h2>Détails du vendeur</h2>
      <div className="info">
        <p><strong>Nom complet :</strong> {vendeur.nom} {vendeur.prenom}</p>
        <p><strong>Email :</strong> {vendeur.email}</p>
        <p><strong>Téléphone :</strong> {vendeur.telephone}</p>
        <p><strong>Mode de paiement :</strong> {vendeur.modePaiement}</p>
      </div>

      <div className="images-section">
        <div>
          <p><strong>Photo de profil :</strong></p>
          <img
            className="detail-image" 
            src={asset(`/uploads/${vendeur.photo_profil}`)} 
            alt="Profil" 
          />
        </div>
        <div>
          <p><strong>CIN recto :</strong></p>
          <img
            className="detail-image" 
            src={asset(`/uploads/${vendeur.cin_recto}`)} 
            alt="CIN recto" 
          />
        </div>
        <div>
          <p><strong>CIN verso :</strong></p>
          <img
            className="detail-image" 
            src={asset(`/uploads/${vendeur.cin_verso}`)} 
            alt="CIN verso" 
          />
        </div>
        <div>
          <p><strong>Justificatif de résidence :</strong></p>
          <img
            className="detail-image" 
            src={asset(`/uploads/${vendeur.residence}`)} 
            alt="Justificatif" 
          />
        </div>
      </div>

      <div className="actions">
        <button className="valider-btn" onClick={valider}>✅ Valider</button>
        <input
          type="text"
          className="remarque-input"
          placeholder="Remarque (si rejet)"
          value={remarque}
          onChange={(e) => setRemarque(e.target.value)}
        />
        <button className="rejeter-btn" onClick={rejeter}>❌ Rejeter</button>
      </div>
    </div>
  );
}

export default VendeurDetails;
